import {
  NAME,
  OWNER,
  PARTNER_COMPANY,
  CUSTOMER_COMPANY,
  INVOICE_LEVEL,
  IO_TYPE,
  VAT_NUMBER,
  TAX_ID,
  CURRENCY,
  EXPENSE_TYPES,
  NETWORK,
  PAYMENT_TERM,
  GDPR_START_DATE,
  ADDRESS,
  CONTACT_PERSON,
  COUNTRY,
  TIME_ZONE,
} from './constants';

const All = [
  NAME,
  OWNER,
  PARTNER_COMPANY,
  CUSTOMER_COMPANY,
  INVOICE_LEVEL,
  IO_TYPE,
  VAT_NUMBER,
  TAX_ID,
  CURRENCY,
  EXPENSE_TYPES,
  NETWORK,
  PAYMENT_TERM,
  GDPR_START_DATE,
  ADDRESS,
  CONTACT_PERSON,
  COUNTRY,
  TIME_ZONE,
];
const PaymentDetails = [ADDRESS, CONTACT_PERSON];

export default function getEditableFields(granularity) {
  const parts = granularity.split(', ');
  return parts.reduce((actions, flag) => {
    switch (flag) {
      case 'all':
        return [...actions, ...All];
      case 'paymentDetails':
        return [...actions, ...PaymentDetails, COUNTRY];
      case 'businessPartnerDetails':
        return [...actions, ...PaymentDetails];
      default:
        return actions;
    }
  }, []);
}
